import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { customFieldsApi } from '@/lib/api';
import type { CustomFieldEntityType } from '@/types';

export function useCustomFields(entityType?: CustomFieldEntityType) {
  return useQuery({
    queryKey: ['customFields', entityType],
    queryFn: () => customFieldsApi.list(entityType),
  });
}

export function useCreateCustomField() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: customFieldsApi.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['customFields'] });
    },
  });
}

export function useUpdateCustomField() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof customFieldsApi.update>[1] }) =>
      customFieldsApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['customFields'] });
    },
  });
}

export function useDeleteCustomField() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: customFieldsApi.delete,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['customFields'] });
    },
  });
}

export function useReorderCustomFields() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: customFieldsApi.reorder,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['customFields'] });
    },
  });
}
